import { render, staticRenderFns } from "./Adminpay24Deposit.vue?vue&type=template&id=3b8d6e61&"
import script from "./Adminpay24Deposit.vue?vue&type=script&lang=js&"
export * from "./Adminpay24Deposit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports